import React, {Component} from 'react';
import {apiService} from '../../common/apiCallService';
import {saveActivity} from '../../common/commonService';
import {baseUrl} from '../../common/config.js';
import Loading from '../Loading.js';
import i18next from 'i18next'
import { DownloadPopup } from 'mygame-components';
import moment from 'moment';
import $ from 'jquery';

var fileDownload = require('react-file-download')

export default class DownloadHandHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: "",
    }
  }

  downloadHandHistory = (fromDate,toDate) => {
    
    this.setState({loading: true})
    console.log("downloading...")
    apiService(baseUrl + '/handHistory/downloads', {
      "fromDate": moment(fromDate).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      "toDate": moment(toDate).endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      "accountName": localStorage.getItem("accountName"),
      "accountNames": localStorage.getItem("accountNames")
    }, (data) => {
       data=JSON.parse(data);
       if (data && data.list !== []) {
        this.setState({loading: false})
        var hands = new Array()
        var fDate = moment(fromDate).format("YYYY-MM-DD").replace(/\-/g, "")
        var tDate = moment(toDate).format("YYYY-MM-DD").replace(/\-/g, "")
        var downloadHandHistory = `${fDate}-${tDate}_${JSON.parse(localStorage.getItem("userRole")).includes("SYS_ADMIN")? localStorage.getItem("currentPlayerAlias"): localStorage.getItem("alias") }.txt`
        for (var i = 0; i < data.list.length; i++) {
          hands.push(data.list[i].handHistory.replace(/\#\*\#Cashout offered to [^#]*/, "").replace(/\#\*\#/g, "\r\n") + "\r\n\r\n");
        }
        fileDownload(hands.join(""), downloadHandHistory)
        $('#download_popup_setting_closeButton_id').click();
        this.addActivity(fromDate,toDate,1,data.list.length);
      } else {
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.location.pathname)
          this.setState({loginRedirect: true})
        }
        this.addActivity(fromDate,toDate,0,0);
        this.setState({
          loading: false,
          error: "No Data Found"
        })
      }
    }, (err) => {
        console.log(err)
        if(err.status === 400 ){
          if(err.responseJSON.errorCode === 1 || err.responseJSON.errorCode === 2){
            if(err.responseJSON.errorCode === 1){
              this.addActivity(fromDate,toDate,2,err.responseJSON.noOfHands);
            } else {
              this.addActivity(fromDate,toDate,0,0);
            }
            this.setState({error: err.responseJSON.msg })  
            console.log(err.responseJSON.msg)
          } 
        }
      this.setState({loading: false})
    })
  }

  addActivity = (fromDate,toDate,errorCodeOrResult,noOfHands)=>{
    let track = {}
    track.hit_page = 'ExportHandsPopup';
    track.hit_type = 'DownloadHands';
    track.hit_attribute1 = errorCodeOrResult.toString();
    track.hit_attribute2 =  moment(fromDate).format('Z');
    track.hit_attribute3 = moment(fromDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    track.hit_attribute4 = moment(toDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    track.hit_attribute5 = noOfHands.toString();
    saveActivity(track);
  }

  render() {
    return (
      <div>
      <DownloadPopup i18next={i18next}  onDownload={this.downloadHandHistory} error={this.state.error} resetError={()=>{this.setState({error: ""})}}/>
      {this.state.loading
        ? <Loading/>
        : null}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/DownloadHandHistory/DownloadHandHistory.js
 **/